// WHAT FOLLOWS A MEETING. Offered once, right after the summary is saved, because that is
// the moment the answer is known — and every one of the three is optional. Closing here is
// a complete action, which the hint says out loud so the dialog does not read as a step
// that must be finished.
//
// EACH ONE HANDS OFF TO WHAT ALREADY EXISTS. Nothing here creates a task or a lead by
// itself, and no new relationship was added to the database for any of them:
//
//   follow-up meeting  opens this screen's own form, prefilled with the same client, job
//                      and owner, carrying `follow_up_of_meeting_id` so the new booking
//                      remembers where it came from.
//   task               opens the SHARED TaskModal, in exactly the shape the task board
//                      already opens it in ({ related_client_id, related_job_id }). The
//                      tasks table is untouched: a meeting's context travels in the task's
//                      own note, not in a new foreign key.
//   lead               goes to the leads screen. A lead is a client row with a pipeline
//                      stage, created by the flow that owns that screen — the calendar has
//                      no business owning a second way to make one.
//
// THE LEAD BUTTON LEAVES THE PAGE, so it says so before it does. A button that silently
// swaps the screen under you is a button nobody presses twice.
import he from '../../i18n/he';
import Button from '../../components/Button';
import { isExternal } from './meetingKind';

export default function FollowUpChoice({ meeting, onFollowUpMeeting, onAddTask, onAddLead, onMakeLead, onClose }) {
  return (
    <div className="follow-up">
      <p className="summary-saved">{he.calendar.summarySaved}</p>
      <h3 className="follow-up-title">{he.calendar.whatNext}</h3>

      <div className="follow-up-actions">
        <Button onClick={() => onFollowUpMeeting(meeting)}>{he.calendar.followUpMeeting}</Button>

        {/* Offered after every kind of meeting: with a client the task is that client's,
            and after an internal or external meeting it opens as an internal task. */}
        <Button variant="subtle" onClick={() => onAddTask(meeting)}>{he.calendar.addTask}</Button>

        {/* Someone outside the system (077) becomes the lead here, prefilled, and this
            meeting is linked to them — no trip to the leads screen. */}
        {isExternal(meeting) ? (
          <Button variant="subtle" onClick={() => onMakeLead(meeting)}>{he.calendar.makeLead}</Button>
        ) : (
          <Button variant="subtle" onClick={onAddLead} title={he.calendar.addLeadHint}>
            {he.calendar.addLead}
          </Button>
        )}
      </div>

      <div className="actions">
        <Button variant="subtle" onClick={onClose}>{he.common.close}</Button>
      </div>
    </div>
  );
}
